import PropTypes from 'prop-types'
import React from 'react'

const ExpenseToken = ({ description, integration, title }) => (
  <div className="token expense-type-token">
    { integration && integration.expense_code && <strong>{ integration.expense_code  } - </strong> }
    { title }<br />
    <span>{ description }</span>
  </div>
)

ExpenseToken.propTypes = {
  description: PropTypes.string,
  integration: PropTypes.object,
  title: PropTypes.string
}

export default ExpenseToken
